// Native theme locales supply interface labels; English is the fallback.
function prismFcText(key, fallback, parameters) {
  if (window.PrismFlightCenterI18n) return window.PrismFlightCenterI18n.text(key, fallback, parameters);
  Object.keys(parameters || {}).forEach(function (name) {
    fallback = fallback.split('__' + name.toUpperCase() + '__').join(String(parameters[name]));
  });
  return fallback;
}
function prismFcLocalUrl(value) {
  return window.PrismFlightCenterI18n ? window.PrismFlightCenterI18n.localUrl(value) : value;
}
function prismFcNormalize(value) {
  return (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/ł/g, 'l').replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/ß/g, 'ss').replace(/[^a-z0-9]/g, '');
}
(function () {
  'use strict';

  // Delegation also supports sections added or re-rendered in the theme editor.
  if (window.prismFcImageEnlargeReady) return;
  window.prismFcImageEnlargeReady = true;
  var dialog, image, canvas, status, zoom, opener;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'prism-fc-section prism-fc-image-dialog';
    dialog.setAttribute('aria-label', prismFcText('image_detail', "Image detail"));
    var toolbar = document.createElement('div');
    toolbar.className = 'prism-fc-image-dialog__toolbar';
    status = document.createElement('p');
    status.className = 'prism-fc-image-dialog__status';
    status.setAttribute('role', 'status');
    zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.textContent = prismFcText('zoom_in', "Zoom in");
    zoom.setAttribute('aria-pressed', 'false');
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = prismFcText('close_image', "Close image");
    close.autofocus = true;
    toolbar.append(status, zoom, close);
    canvas = document.createElement('div');
    canvas.className = 'prism-fc-image-dialog__canvas';
    canvas.tabIndex = 0;
    canvas.setAttribute('aria-label', prismFcText('image_pan', "Image; scroll to pan when zoomed"));
    image = document.createElement('img');
    canvas.appendChild(image);
    dialog.append(toolbar, canvas);
    document.body.appendChild(dialog);
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('prism-fc-image-open');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    zoom.addEventListener('click', function () {
      var enlarged = canvas.classList.toggle('is-zoomed');
      zoom.textContent = enlarged ? prismFcText('fit_image', "Fit image") : prismFcText('zoom_in', "Zoom in");
      zoom.setAttribute('aria-pressed', String(enlarged));
      canvas.scrollTo(0, 0);
      status.textContent = enlarged ? prismFcText('image_explore', "Swipe or scroll to explore the image.") : prismFcText('image_full', "Full image. Choose Zoom in for detail.");
    });
    image.addEventListener('load', function () {
      zoom.disabled = false;
      status.textContent = prismFcText('image_full', "Full image. Choose Zoom in for detail.");
    });
    image.addEventListener('error', function () {
      status.textContent = prismFcText('image_failed', "This image could not be loaded. Please close and try again.");
      zoom.disabled = true;
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-prism-fc-enlarge-image]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey ||
        event.shiftKey || event.altKey || !window.HTMLDialogElement ||
        typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    event.preventDefault();
    if (!dialog) buildDialog();
    opener = link;
    canvas.classList.remove('is-zoomed');
    zoom.textContent = prismFcText('zoom_in', "Zoom in");
    zoom.setAttribute('aria-pressed', 'false');
    zoom.disabled = true;
    status.textContent = prismFcText('image_loading', "Loading image…");
    image.alt = link.getAttribute('data-prism-fc-image-alt') || prismFcText('instruction_diagram', "Instruction diagram");
    // Remove the previous source so repeated opens trigger a fresh load event.
    image.removeAttribute('src');
    image.src = link.href;
    document.documentElement.classList.add('prism-fc-image-open');
    dialog.showModal();
    canvas.scrollTo(0, 0);
  });
})();

(function () {
  'use strict';

  var contentsSelector = '[data-prism-fc-auto-contents]';
  var sectionSelector = '.prism-fc-section[id][data-prism-fc-section]';
  var panoramaSelector = '.prism-fc-single-line__mobile-viewport';
  var accordionButtonSelector = '[data-prism-fc-accordion-button]';
  var floatingContentsSelector = '[data-prism-fc-floating-contents]';
  var refreshFrame;
  var panoramaFrame;
  var floatingContentsFrame;
  var contentsGroupId = 0;

  function getContentsSubtopics(section) {
    if (section.getAttribute('data-prism-fc-include-subtopics') === 'false') return [];

    // Only opt-in rich-text fields whose existing styling defines subheadings.
    // Keep the first (deliberately hidden) single-line H3 out of navigation.
    section.querySelectorAll('[data-prism-fc-toc-richtext]').forEach(function (field) {
      var kind = field.getAttribute('data-prism-fc-toc-richtext');
      var selector = kind === 'line-topics' ? ':scope > h3:not(:first-child)' :
        kind === 'setup-topics' ? ':scope > .prism-fc-simple-setup__topic' : null;
      if (!selector) return;
      field.querySelectorAll(selector).forEach(function (heading, index) {
        if (!heading.id) {
          heading.id = field.getAttribute('data-prism-fc-toc-id-prefix') + '-' + (index + 1);
        }
        heading.setAttribute('data-prism-fc-toc-subheading', '');
        heading.setAttribute('tabindex', '-1');
      });
    });

    var seen = new Set();
    return Array.from(section.querySelectorAll('[data-prism-fc-toc-subheading][id]'))
      .filter(function (heading) {
        if (heading.closest(sectionSelector) !== section || heading.closest('[hidden]') ||
            !heading.textContent.trim() || seen.has(heading.id)) return false;
        seen.add(heading.id);
        return true;
      })
      .map(function (heading) {
        var label = heading.getAttribute('data-prism-fc-toc-label') || heading.textContent;
        return { anchor: heading.id, label: label.trim() };
      });
  }

  // Both Contents surfaces use the same tree, but keep their own open groups.
  // Avoid rebuilding unchanged lists so focus and expanded state survive refreshes.
  function renderContentsList(list, entries, prefix) {
    var signature = JSON.stringify(entries);
    var expanded = list.prismFcExpandedGroups || new Set();
    list.prismFcEntries = entries;
    if (list.prismFcContentsSignature === signature) return;
    list.prismFcContentsSignature = signature;
    list.prismFcExpandedGroups = expanded;
    var fragment = document.createDocumentFragment();

    entries.forEach(function (entry) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      item.className = prefix + '__item';
      link.className = prefix + '__link';
      link.href = '#' + entry.anchor;
      link.textContent = entry.label;
      item.appendChild(link);

      if (entry.children && entry.children.length) {
        var row = document.createElement('div');
        var button = document.createElement('button');
        var icon = document.createElement('span');
        var panel = document.createElement('div');
        var clip = document.createElement('div');
        var children = document.createElement('ul');
        var panelId = 'PrismFcContentsGroup-' + (++contentsGroupId);
        item.classList.add('prism-fc-toc-group');
        row.className = 'prism-fc-toc-group__row';
        button.type = 'button';
        button.className = 'prism-fc-toc-group__toggle';
        button.setAttribute('aria-controls', panelId);
        icon.className = 'prism-fc-toc-group__chevron';
        icon.setAttribute('aria-hidden', 'true');
        button.appendChild(icon);
        panel.id = panelId;
        panel.className = 'prism-fc-toc-group__panel';
        clip.className = 'prism-fc-toc-group__clip';
        children.className = 'prism-fc-toc-group__list';

        entry.children.forEach(function (child) {
          var childItem = document.createElement('li');
          var childLink = document.createElement('a');
          childLink.className = prefix + '__link prism-fc-toc-group__sublink';
          childLink.href = '#' + child.anchor;
          childLink.textContent = child.label;
          childItem.appendChild(childLink);
          children.appendChild(childItem);
        });

        function setExpanded(open) {
          if (open) expanded.add(entry.anchor);
          else expanded.delete(entry.anchor);
          button.setAttribute('aria-expanded', String(open));
          button.setAttribute('aria-label', prismFcText(open ? 'collapse_topics' : 'expand_topics', open ? 'Collapse __LABEL__ subtopics' : 'Expand __LABEL__ subtopics', { label: entry.label }));
          panel.setAttribute('aria-hidden', String(!open));
          panel.inert = !open;
          panel.classList.toggle('is-expanded', open);
        }

        button.addEventListener('click', function () {
          setExpanded(button.getAttribute('aria-expanded') !== 'true');
        });
        setExpanded(expanded.has(entry.anchor));
        row.appendChild(link);
        row.appendChild(button);
        clip.appendChild(children);
        panel.appendChild(clip);
        item.appendChild(row);
        item.appendChild(panel);
      }

      fragment.appendChild(item);
    });
    list.replaceChildren(fragment);
  }

  function getSectionLabel(section) {
    var explicitLabel = section.getAttribute('data-prism-fc-toc-label');
    var heading;

    if (explicitLabel && explicitLabel.trim()) {
      return explicitLabel.trim();
    }

    heading = section.querySelector('.prism-fc-heading-band__title');
    return heading ? heading.textContent.trim() : '';
  }

  function refreshContents() {
    var contentsNavigations = document.querySelectorAll(contentsSelector);

    contentsNavigations.forEach(function (navigation) {
      var list = navigation.querySelector('[data-prism-fc-contents-list]');
      var introduction = navigation.closest('[data-prism-fc-section="introduction"]');
      var seenAnchors = new Set();
      var entries = [];

      if (!list) return;

      document.querySelectorAll(sectionSelector).forEach(function (section) {
        var anchor = section.id;
        var label;

        if (
          section === introduction ||
          section.getAttribute('data-prism-fc-include-in-contents') === 'false' ||
          !anchor ||
          seenAnchors.has(anchor)
        ) {
          return;
        }

        label = getSectionLabel(section);
        if (!label) return;

        seenAnchors.add(anchor);
        entries.push({ anchor: anchor, label: label, children: getContentsSubtopics(section) });
      });

      renderContentsList(list, entries, 'prism-fc-contents');

      navigation.hidden = entries.length === 0;
    });
  }

  function refreshFloatingContents() {
    document.querySelectorAll(floatingContentsSelector).forEach(function (floatingContents) {
      var introduction = floatingContents.closest('[data-prism-fc-section="introduction"]');
      var sourceNavigation = introduction
        ? introduction.querySelector('.prism-fc-contents')
        : null;
      var sourceList = sourceNavigation
        ? sourceNavigation.querySelector('[data-prism-fc-contents-list]')
        : null;
      var drawerList = floatingContents.querySelector(
        '[data-prism-fc-floating-contents-list]'
      );

      if (!drawerList) return;

      var entries = sourceList && sourceList.prismFcEntries;
      if (!entries) {
        // Preserve the existing flat list when Introduction uses manual links.
        var sourceLinks = sourceNavigation
          ? sourceNavigation.querySelectorAll('.prism-fc-contents__link')
          : [];
        entries = Array.from(sourceLinks).map(function (sourceLink) {
          return { href: sourceLink.getAttribute('href'), label: sourceLink.textContent.trim() };
        }).filter(function (entry) {
          return entry.href && entry.href.charAt(0) === '#' && entry.label;
        }).map(function (entry) {
          return { anchor: entry.href.slice(1), label: entry.label, children: [] };
        });
      }
      renderContentsList(drawerList, entries, 'prism-fc-floating-contents');

      floatingContents.hidden = drawerList.children.length === 0;
      if (floatingContents.hidden) {
        floatingContents.classList.remove('is-tab-visible');
      }
    });
  }

  function finishClosingFloatingContents(dialog, restoreFocus, onClosed) {
    var floatingContents = dialog.closest(floatingContentsSelector);
    var openButton = floatingContents
      ? floatingContents.querySelector('[data-prism-fc-floating-contents-open]')
      : null;

    window.clearTimeout(dialog.prismFcCloseTimer);
    dialog.prismFcCloseTimer = null;
    dialog.classList.remove('is-open');

    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    document.documentElement.classList.remove('prism-fc-drawer-open');
    if (floatingContents) floatingContents.classList.remove('is-drawer-open');

    if (openButton) {
      openButton.setAttribute('aria-expanded', 'false');
      if (restoreFocus) openButton.focus({ preventScroll: true });
    }

    if (typeof onClosed === 'function') onClosed();
  }

  function closeFloatingContents(dialog, restoreFocus, closeImmediately, onClosed) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!dialog || !dialog.hasAttribute('open')) return;

    dialog.classList.remove('is-open');
    window.clearTimeout(dialog.prismFcCloseTimer);

    if (closeImmediately || reduceMotion) {
      finishClosingFloatingContents(dialog, restoreFocus, onClosed);
      return;
    }

    dialog.prismFcCloseTimer = window.setTimeout(function () {
      finishClosingFloatingContents(dialog, restoreFocus, onClosed);
    }, 220);
  }

  function openFloatingContents(floatingContents) {
    var openButton = floatingContents.querySelector(
      '[data-prism-fc-floating-contents-open]'
    );
    var dialog = floatingContents.querySelector(
      '[data-prism-fc-floating-contents-dialog]'
    );
    var closeButton;

    if (
      !dialog ||
      dialog.hasAttribute('open')
    ) {
      return;
    }

    window.clearTimeout(dialog.prismFcCloseTimer);
    floatingContents.classList.add('is-drawer-open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    dialog.getBoundingClientRect();
    dialog.classList.add('is-open');
    document.documentElement.classList.add('prism-fc-drawer-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');

    closeButton = dialog.querySelector('[data-prism-fc-floating-contents-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function updateFloatingContentsVisibility() {
    document.querySelectorAll(floatingContentsSelector).forEach(function (floatingContents) {
      var introduction = floatingContents.closest('[data-prism-fc-section="introduction"]');
      var sourceNavigation = introduction
        ? introduction.querySelector('.prism-fc-contents')
        : null;
      var dialog = floatingContents.querySelector(
        '[data-prism-fc-floating-contents-dialog]'
      );
      var shouldShow =
        !floatingContents.hidden &&
        sourceNavigation &&
        sourceNavigation.getBoundingClientRect().bottom <= 0;

      if (dialog && dialog.hasAttribute('open')) return;

      floatingContents.classList.toggle('is-tab-visible', Boolean(shouldShow));
    });
  }

  function scheduleFloatingContentsVisibility() {
    window.cancelAnimationFrame(floatingContentsFrame);
    floatingContentsFrame = window.requestAnimationFrame(
      updateFloatingContentsVisibility
    );
  }

  function initializeFloatingContents() {
    document.querySelectorAll(floatingContentsSelector).forEach(function (floatingContents) {
      var openButton;
      var dialog;

      if (floatingContents.getAttribute('data-prism-fc-floating-ready') === 'true') {
        return;
      }

      floatingContents.setAttribute('data-prism-fc-floating-ready', 'true');
      openButton = floatingContents.querySelector(
        '[data-prism-fc-floating-contents-open]'
      );
      dialog = floatingContents.querySelector(
        '[data-prism-fc-floating-contents-dialog]'
      );

      if (!openButton || !dialog) return;

      openButton.addEventListener('click', function () {
        openFloatingContents(floatingContents);
      });

      dialog.addEventListener('click', function (event) {
        var closeButton = event.target.closest(
          '[data-prism-fc-floating-contents-close]'
        );
        var contentsLink = event.target.closest('.prism-fc-floating-contents__link');
        var bounds;
        var clickedBackdrop;

        if (closeButton) {
          closeFloatingContents(dialog, true, false);
          return;
        }

        if (contentsLink) {
          var href = contentsLink.getAttribute('href');
          var target = href && href.charAt(0) === '#'
            ? document.getElementById(decodeURIComponent(href.slice(1)))
            : null;

          if (!target) {
            closeFloatingContents(dialog, false, false);
            return;
          }

          event.preventDefault();
          closeFloatingContents(dialog, false, false, function () {
            var reduceMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

            if (target.hasAttribute('data-prism-fc-toc-subheading')) {
              target.focus({ preventScroll: true });
            }
            target.scrollIntoView({
              behavior: reduceMotion ? 'auto' : 'smooth',
              block: 'start'
            });

            if (window.history && typeof window.history.pushState === 'function') {
              window.history.pushState(null, '', href);
            }
          });
          return;
        }

        if (event.target !== dialog) return;

        bounds = dialog.getBoundingClientRect();
        clickedBackdrop =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (clickedBackdrop) closeFloatingContents(dialog, true, false);
      });

      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeFloatingContents(dialog, true, false);
      });

      dialog.addEventListener('close', function () {
        dialog.classList.remove('is-open');
        floatingContents.classList.remove('is-drawer-open');
        document.documentElement.classList.remove('prism-fc-drawer-open');
        openButton.setAttribute('aria-expanded', 'false');
      });
    });

    scheduleFloatingContentsVisibility();
  }

  function getPanoramaPanelCount(viewport) {
    return viewport.getAttribute('data-panorama-panels') === '2' ? 2 : 3;
  }

  function getPanoramaPanelWidth(viewport) {
    var panorama = viewport.querySelector('.prism-fc-single-line__mobile-panorama');

    if (!panorama) return viewport.clientWidth;
    return panorama.getBoundingClientRect().width / getPanoramaPanelCount(viewport);
  }

  function updatePanoramaPosition(viewport) {
    var panelWidth = getPanoramaPanelWidth(viewport);
    var panelIndex;

    if (panelWidth === 0) return;

    panelIndex = Math.max(0, Math.min(getPanoramaPanelCount(viewport) - 1, Math.round(viewport.scrollLeft / panelWidth)));

    if (panelIndex === 0) {
      viewport.setAttribute('data-panorama-position', 'first');
    } else if (panelIndex === getPanoramaPanelCount(viewport) - 1) {
      viewport.setAttribute('data-panorama-position', 'last');
    } else {
      viewport.setAttribute('data-panorama-position', 'middle');
    }
  }

  function schedulePanoramaRefresh() {
    window.cancelAnimationFrame(panoramaFrame);
    panoramaFrame = window.requestAnimationFrame(function () {
      document.querySelectorAll(panoramaSelector).forEach(updatePanoramaPosition);
    });
  }

  function enableMouseDragging(viewport) {
    var activePointer = null;
    var startX = 0;
    var startScrollLeft = 0;
    var hasMoved = false;

    function finishDrag(event) {
      var panelWidth;
      var targetPanel;
      var reduceMotion;

      if (activePointer === null || event.pointerId !== activePointer) return;

      activePointer = null;
      viewport.classList.remove('is-mouse-dragging');

      if (viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }

      if (!hasMoved) return;

      panelWidth = getPanoramaPanelWidth(viewport);
      if (panelWidth === 0) return;

      targetPanel = Math.max(0, Math.min(getPanoramaPanelCount(viewport) - 1, Math.round(viewport.scrollLeft / panelWidth)));
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      viewport.scrollTo({
        left: targetPanel * panelWidth,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      activePointer = event.pointerId;
      startX = event.clientX;
      startScrollLeft = viewport.scrollLeft;
      hasMoved = false;
      viewport.classList.add('is-mouse-dragging');

      if (viewport.setPointerCapture) {
        viewport.setPointerCapture(event.pointerId);
      }
    });

    viewport.addEventListener('pointermove', function (event) {
      var distance;

      if (activePointer === null || event.pointerId !== activePointer) return;

      distance = event.clientX - startX;
      if (Math.abs(distance) > 3) hasMoved = true;
      if (!hasMoved) return;

      event.preventDefault();
      viewport.scrollLeft = startScrollLeft - distance;
    });

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);
  }

  function initializePanoramas() {
    document.querySelectorAll(panoramaSelector).forEach(function (viewport) {
      if (viewport.getAttribute('data-prism-fc-swipe-ready') === 'true') return;

      viewport.setAttribute('data-prism-fc-swipe-ready', 'true');
      viewport.addEventListener('scroll', schedulePanoramaRefresh, { passive: true });
      enableMouseDragging(viewport);
      updatePanoramaPosition(viewport);
    });
  }

  function setAccordionExpanded(button, expanded) {
    var panelId = button.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    if (!panel) return;

    panel.classList.toggle('is-open', expanded);
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');

    if (expanded) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function initializeAccordions() {
    document.querySelectorAll(accordionButtonSelector).forEach(function (button) {
      if (button.getAttribute('data-prism-fc-accordion-ready') === 'true') return;

      button.setAttribute('data-prism-fc-accordion-ready', 'true');
      setAccordionExpanded(button, button.getAttribute('aria-expanded') === 'true');

      button.addEventListener('click', function () {
        setAccordionExpanded(button, button.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function initializePackingLoop(gallery) {
    var viewport = gallery.querySelector('[data-prism-fc-packing-slides]');
    var slides = Array.from(gallery.querySelectorAll('[data-prism-fc-packing-slide]'));
    var playback = gallery.querySelector('[data-prism-fc-packing-playback]');
    var button = gallery.querySelector('[data-prism-fc-packing-play]');
    var animationLabel = gallery.getAttribute('data-animation-label') || prismFcText('packing_animation', "Packing animation");
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var playing = !motion.matches;
    var visible = false;
    var index = 0;
    var timer;
    var observer;
    var delay = Math.max(400, Number(gallery.getAttribute('data-frame-delay')) || 900);
    if (!viewport || !slides.length) return;

    function showFrame(next) {
      index = next;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }

    function updateButton() {
      if (!button) return;
      button.setAttribute('aria-label', prismFcText(playing ? 'pause_animation' : 'play_animation', playing ? 'Pause: __LABEL__' : 'Play: __LABEL__', { label: animationLabel }));
      button.firstElementChild.textContent = playing ? '\u275A\u275A' : '\u25B6';
    }

    function scheduleFrame() {
      window.clearTimeout(timer);
      if (!playing || !visible || document.hidden || slides.length < 2) return;
      timer = window.setTimeout(function () {
        var next = (index + 1) % slides.length;
        var image = slides[next].querySelector('img');
        // Hold the current frame until the next image is ready, avoiding a blank flash.
        if (!image || (image.complete && image.naturalWidth > 0)) showFrame(next);
        scheduleFrame();
      }, delay);
    }

    function toggle() { playing = !playing; updateButton(); scheduleFrame(); }
    function onMotionChange() {
      if (motion.matches) playing = false;
      updateButton();
      scheduleFrame();
    }
    function loadFrames() {
      slides.forEach(function (slide) {
        var image = slide.querySelector('img');
        if (image) image.loading = 'eager';
      });
    }

    gallery.classList.add('is-ready', 'is-loop');
    viewport.removeAttribute('tabindex');
    viewport.setAttribute('aria-label', animationLabel);
    if (playback) playback.hidden = false;
    if (button) button.addEventListener('click', toggle);
    motion.addEventListener('change', onMotionChange);
    document.addEventListener('visibilitychange', scheduleFrame);
    showFrame(0);
    updateButton();
    if (window.IntersectionObserver) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) loadFrames();
        scheduleFrame();
      });
      observer.observe(gallery);
    } else {
      visible = true;
      loadFrames();
      scheduleFrame();
    }
    gallery.prismFcPacking = {
      select: function (slide) {
        var selected = slides.indexOf(slide);
        if (selected < 0) return;
        playing = false;
        loadFrames();
        showFrame(selected);
        updateButton();
        scheduleFrame();
      },
      destroy: function () {
        window.clearTimeout(timer);
        if (observer) observer.disconnect();
        if (button) button.removeEventListener('click', toggle);
        motion.removeEventListener('change', onMotionChange);
        document.removeEventListener('visibilitychange', scheduleFrame);
        if (playback) playback.hidden = true;
        gallery.classList.remove('is-ready', 'is-loop');
        slides.forEach(function (slide) { slide.classList.remove('is-active'); slide.removeAttribute('aria-hidden'); });
        delete gallery.prismFcPacking;
      }
    };
  }

  function initializePackingGalleries() {
    document.querySelectorAll('[data-prism-fc-packing-gallery]').forEach(function (gallery) {
      if (!gallery.prismFcPacking) initializePackingLoop(gallery);
    });
  }

  function refreshFlightCenter() {
    refreshContents();
    refreshFloatingContents();
    initializeFloatingContents();
    initializePanoramas();
    initializeAccordions();
    initializePackingGalleries();
  }

  function scheduleRefresh() {
    window.cancelAnimationFrame(refreshFrame);
    refreshFrame = window.requestAnimationFrame(refreshFlightCenter);
  }

  if (window.PrismFlightCenterContents) {
    window.PrismFlightCenterContents.refresh();
    return;
  }

  window.PrismFlightCenterContents = {
    refresh: scheduleRefresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', scheduleRefresh);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    // The editor can remove an open drawer without firing its close event.
    // Release the preview's scroll lock before its section is replaced.
    event.target.querySelectorAll('[data-prism-fc-floating-contents-dialog]').forEach(function (dialog) {
      closeFloatingContents(dialog, false, true);
    });
    event.target.querySelectorAll('[data-prism-fc-packing-gallery]').forEach(function (gallery) {
      if (gallery.prismFcPacking) gallery.prismFcPacking.destroy();
    });
  });
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target && event.target.closest
      ? event.target.closest('.prism-fc-troubleshooting__item')
      : null;
    var button = block ? block.querySelector(accordionButtonSelector) : null;

    if (button) setAccordionExpanded(button, true);
    var slide = event.target && event.target.closest
      ? event.target.closest('[data-prism-fc-packing-slide]')
      : null;
    var gallery = slide ? slide.closest('[data-prism-fc-packing-gallery]') : null;
    if (gallery && gallery.prismFcPacking) gallery.prismFcPacking.select(slide);
  });
  window.addEventListener('scroll', scheduleFloatingContentsVisibility, {
    passive: true
  });
  window.addEventListener('resize', scheduleFloatingContentsVisibility, {
    passive: true
  });
  window.addEventListener('resize', schedulePanoramaRefresh, { passive: true });
})();

/*
 * Full-document PDF display: every page is rendered at the column width.
 * No pagination or custom touch handling. Desktop can expand the same pages
 * into a browser-width native dialog; the inline document is never clipped.
 *
 * PDF.js (Mozilla, Apache-2.0) loads from a fixed jsDelivr version. Keep the
 * display engine, worker, fonts, CMaps and WASM on the SAME version.
 */
(() => {
  if (customElements.get('prism-fc-pdf-manual')) return;

  const base = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@6.3.289/';
  let library;

  function getLibrary() {
    if (!library) {
      library = import(base + 'legacy/build/pdf.min.mjs')
        .then(pdfjs => {
          pdfjs.GlobalWorkerOptions.workerSrc = base + 'legacy/build/pdf.worker.min.mjs';
          return pdfjs;
        })
        .catch(error => {
          library = null;
          throw error;
        });
    }
    return library;
  }

  class PrismPdfManual extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.revision = (this.revision || 0) + 1;
      this.pages = [];
      this.surface = this.querySelector('.prism-fc-pdf__pages');
      this.status = this.querySelector('[data-pdf-status]');
      this.fallback = this.querySelector('[data-pdf-fallback]');
      this.fallback.toggleAttribute('data-visible', this.dataset.showOriginalLink === 'true');
      this.surface.replaceChildren();
      this.status.hidden = false;
      this.status.textContent = prismFcText('pdf_loading', "Loading manual…");

      this.dialog = this.querySelector('dialog');
      this.home = this.querySelector('[data-pdf-home]');
      this.documentContent = this.querySelector('[data-pdf-document]');
      this.fullscreenButton = this.querySelector('[data-pdf-fullscreen]');
      this.downloadStatus = this.querySelector('[data-pdf-download-status]');
      this.downloadStatus.hidden = true;
      this.querySelector('[data-pdf-download]').removeAttribute('aria-busy');
      this.querySelector('[data-pdf-download]').removeAttribute('aria-disabled');
      this.objectUrls = new Map();
      this.desktop = window.matchMedia('(min-width: 750px)');
      const options = { signal: this.controller.signal };
      this.fullscreenButton.hidden = true;
      this.fullscreenButton.addEventListener('click', () => this.expand(), options);
      this.querySelector('[data-pdf-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.desktop.addEventListener('change', () => {
        if (!this.desktop.matches && this.dialog.open) this.dialog.close();
      }, options);
      this.querySelector('[data-pdf-download]').addEventListener('click', event => this.download(event), options);

      this.resize = new ResizeObserver(() => {
        const width = this.surface.clientWidth;
        if (!this.pages.length || !width || width === this.width) return;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.render(), 150);
      });
      this.resize.observe(this.surface);

      // Start the whole manual immediately, including pages below the fold.
      this.load(this.controller.signal);
    }

    async load(signal) {
      try {
        const pdfjs = await getLibrary();
        if (signal.aborted) return;

        const url = new URL(this.dataset.pdfUrl, location.href);
        if (!['https:', 'http:'].includes(url.protocol)) {
          throw new Error('Unsupported PDF URL');
        }

        const task = pdfjs.getDocument({
          url: url.href,
          cMapUrl: base + 'cmaps/',
          cMapPacked: true,
          standardFontDataUrl: base + 'standard_fonts/',
          wasmUrl: base + 'wasm/',
          isEvalSupported: false
        });
        this.task = task;
        task.onPassword = () => {
          task.destroy().catch(() => {});
          if (!signal.aborted) this.fail();
        };

        const pdf = await task.promise;
        if (signal.aborted) return;
        this.pdf = pdf;

        const entries = [];
        for (let number = 1; number <= pdf.numPages; number++) {
          const page = await pdf.getPage(number);
          if (signal.aborted) return;

          const original = page.getViewport({ scale: 1 });
          const wrapper = document.createElement('div');
          wrapper.className = 'prism-fc-pdf__page';
          wrapper.setAttribute('role', 'group');
          wrapper.setAttribute('aria-label', prismFcText('pdf_page', 'Manual page __CURRENT__ of __TOTAL__', { current: number, total: pdf.numPages }));

          // Reserve each page's exact shape before its bitmap arrives.
          wrapper.style.aspectRatio = `${original.width} / ${original.height}`;
          const image = document.createElement('div');
          const text = document.createElement('div');
          text.className = 'prism-fc-pdf__sr';
          wrapper.append(image, text);
          entries.push({ page, original, wrapper, image, text, number, textLoaded: false });
        }

        this.pages = entries;
        this.surface.replaceChildren(...entries.map(entry => entry.wrapper));
        await this.render();
      } catch (error) {
        if (!signal.aborted) this.fail();
      }
    }

    fail() {
      this.status.hidden = false;
      this.status.textContent = prismFcText('pdf_failed', "The complete manual could not be displayed. Please open the original PDF below.");
      this.fallback.setAttribute('data-visible', '');
      this.surface.setAttribute('aria-busy', 'false');
    }

    expand() {
      if (!this.desktop.matches || !this.pages.length || this.dialog.open) return;
      // Keep the original layout height, so closing returns to the same place.
      this.home.style.height = `${this.home.getBoundingClientRect().height}px`;
      this.expanded = true;
      this.querySelector('[data-pdf-expanded]').append(this.documentContent);
      try {
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        this.querySelector('[data-pdf-close]').focus({ preventScroll: true });
        this.render();
      } catch (_) {
        this.restore();
      }
    }

    restore(focus = true) {
      if (!this.expanded) return;
      this.expanded = false;
      this.home.append(this.documentContent);
      this.home.style.height = '';
      if (focus && this.isConnected && this.desktop.matches) {
        this.fullscreenButton.focus({ preventScroll: true });
      }
      if (this.isConnected) this.render();
    }

    async download(event) {
      if (event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.downloading) return;
      this.downloading = true;
      const signal = this.controller.signal;
      const button = event.currentTarget;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      this.downloadStatus.hidden = true;
      try {
        const url = new URL(this.dataset.pdfUrl, location.href);
        let blob;
        if (this.pdf) {
          // PDF.js provides the unmodified original bytes, not canvas images.
          const bytes = await this.pdf.getData();
          blob = new Blob([bytes], { type: 'application/pdf' });
        } else {
          const response = await fetch(url.href, { signal });
          if (!response.ok) throw new Error('PDF download failed');
          blob = await response.blob();
        }
        if (signal.aborted) return;
        let filename = decodeURIComponent(url.pathname.split('/').pop() || 'manual.pdf');
        filename = filename.replace(/[\\/:*?"<>|\u0000-\u001f]/g, '-');
        if (!/\.pdf$/i.test(filename)) filename += '.pdf';
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        link.hidden = true;
        this.append(link);
        link.click();
        link.remove();
        const timer = setTimeout(() => {
          URL.revokeObjectURL(objectUrl);
          this.objectUrls.delete(objectUrl);
        }, 60000);
        this.objectUrls.set(objectUrl, timer);
      } catch (_) {
        if (!signal.aborted) {
          this.downloadStatus.textContent = prismFcText('pdf_download_failed', "The download could not start. Open the original PDF below to save it from your browser.");
          this.downloadStatus.hidden = false;
          this.fallback.setAttribute('data-visible', '');
        }
      } finally {
        if (!signal.aborted) {
          this.downloading = false;
          button.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
        }
      }
    }

    async render() {
      if (!this.pages.length || !this.controller || this.controller.signal.aborted) return;

      const signal = this.controller.signal;
      const revision = ++this.revision;
      const entries = this.pages;
      const current = () => !signal.aborted && revision === this.revision;
      this.renderTask?.cancel();
      this.width = this.surface.clientWidth;
      if (!this.width) return;

      this.surface.setAttribute('aria-busy', 'true');
      let failed = false;

      // Bound total retained canvas pixels as well as individual bitmap size.
      // This affects rendering resolution only: every complete page stays visible.
      const pixelBudget = Math.min(8000000, 32000000 / entries.length);
      for (const entry of entries) {
        try {
          if (!current()) return;
          const viewport = entry.page.getViewport({
            scale: this.width / entry.original.width
          });
          const density = Math.min(
            window.devicePixelRatio || 1,
            3,
            4096 / Math.max(viewport.width, viewport.height),
            Math.sqrt(pixelBudget / (viewport.width * viewport.height))
          );
          const canvas = document.createElement('canvas');
          canvas.width = Math.ceil(viewport.width * density);
          canvas.height = Math.ceil(viewport.height * density);
          // Preserve the PDF's aspect ratio rather than integer bitmap rounding.
          canvas.style.aspectRatio = `${entry.original.width} / ${entry.original.height}`;
          canvas.setAttribute('role', 'img');
          canvas.setAttribute('aria-label', prismFcText('pdf_page_image', 'PDF page __CURRENT__. Open the original PDF for its text and diagrams.', { current: entry.number }));

          const task = entry.page.render({
            canvasContext: canvas.getContext('2d'),
            viewport,
            transform: [density, 0, 0, density, 0, 0]
          });
          this.renderTask = task;
          await task.promise;
          if (!current()) return;

          entry.image.replaceChildren(canvas);

          // Expose extracted copy to screen readers without a visible text panel.
          // An untagged PDF's reading order is not guaranteed to match its layout.
          if (!entry.textLoaded) {
            try {
              const content = await entry.page.getTextContent();
              if (!current()) return;
              entry.text.textContent = content.items
                .map(item => (item.str || '') + (item.hasEOL ? '\n' : ' '))
                .join('')
                .trim();
              entry.textLoaded = true;
            } catch (_) {
              // Keep the labeled image and original-PDF fallback.
            }
          }
          if (entry.text.textContent) canvas.setAttribute('aria-hidden', 'true');
        } catch (error) {
          if (!current()) return;
          if (error.name !== 'RenderingCancelledException') failed = true;
        }
      }

      if (!current()) return;
      this.surface.setAttribute('aria-busy', 'false');
      if (failed) {
        this.fail();
      } else {
        this.status.textContent = '';
        this.status.hidden = true;
        this.fallback.toggleAttribute('data-visible', this.dataset.showOriginalLink === 'true' || !this.downloadStatus.hidden);
        this.fullscreenButton.hidden = typeof this.dialog.showModal !== 'function';
      }
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore(false);
      this.controller?.abort();
      this.controller = null;
      this.revision++;
      this.resize?.disconnect();
      clearTimeout(this.resizeTimer);
      this.renderTask?.cancel();
      this.task?.destroy().catch(() => {});
      for (const [url, timer] of this.objectUrls || []) {
        clearTimeout(timer);
        URL.revokeObjectURL(url);
      }
      this.objectUrls?.clear();
      this.pdf = null;
      this.downloading = false;
      this.pages = [];
    }
  }

  customElements.define('prism-fc-pdf-manual', PrismPdfManual);
})();

(function () {
  'use strict';

  if (customElements.get('prism-fc-manual-library')) return;

  const libraries = new Set();

  function refreshLibraries() {
    const active = Array.from(libraries).filter(library => library.isConnected);
    active.forEach(library => {
      const scope = library.closest('main') || document;
      library.leader = library.dataset.libraryRole === 'discontinued'
        ? active.find(other => other.dataset.libraryRole !== 'discontinued' && (other.closest('main') || document) === scope) || library
        : library;
    });
    active.forEach(library => {
      library.hidden = false;
      library.classList.toggle('prism-fc-library--joined-archive', library.leader !== library);
      library.classList.remove('prism-fc-library--joined-next', 'prism-fc-library--first-results');
      library.querySelector('[data-library-controls]').hidden = library.leader !== library;
      library.querySelector('[data-library-empty]').hidden = true;
      if (library.leader !== library) return;
      library.members = active.filter(other => other.leader === library);
      library.cards = library.members.flatMap(member => Array.from(member.querySelectorAll('[data-library-card]')));
      library.groups = library.members.flatMap(member => Array.from(member.querySelectorAll('[data-library-group]')));
      library.index = new Map(library.cards.map(card => [card, library.normalize(card.dataset.librarySearchText)]));
      library.input.setAttribute('aria-controls', library.members.map(member => member.querySelector('.prism-fc-library__results').id).join(' '));
      const availability = library.querySelector('[data-library-availability-controls]');
      const showAvailability = library.dataset.libraryShowAvailability !== 'false' && library.members.some(member => member !== library);
      if (availability) availability.hidden = !showAvailability;
      if (!showAvailability) library.availability = 'all';
    });
    active.filter(library => library.leader === library).forEach(library => library.update());
  }

  class PrismManualLibrary extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.input = this.querySelector('[data-library-search]');
      if (!this.input) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.category = 'all';
      this.availability = 'all';
      const initialSearch = new URLSearchParams(window.location.search).get('manual_search');
      if (initialSearch !== null) this.input.value = initialSearch.slice(0, 120);
      this.buttons = Array.from(this.querySelectorAll('[data-library-filter]'));
      this.availabilityButtons = Array.from(this.querySelectorAll('button[data-library-availability]'));
      this.querySelector('form').addEventListener('submit', event => event.preventDefault(), options);
      this.input.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.update(), 120);
      }, options);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.libraryFilter;
        this.update();
      }, options));
      this.availabilityButtons.forEach(button => button.addEventListener('click', () => {
        this.availability = button.dataset.libraryAvailability;
        this.update();
      }, options));
      this.querySelectorAll('[data-library-reset]').forEach(button => button.addEventListener('click', () => {
        this.reset();
        this.input.focus();
      }, options));
      document.addEventListener('shopify:block:select', event => {
        if (this.leader !== this) return;
        const card = this.cards.find(item => item.dataset.libraryBlockId === event.detail?.blockId);
        if (card && card.hidden) this.reset();
      }, options);
      libraries.add(this);
      refreshLibraries();
    }

    normalize(value) {
      return prismFcNormalize(value);
    }

    reset() {
      clearTimeout(this.searchTimer);
      this.input.value = '';
      this.category = 'all';
      this.availability = 'all';
      this.update();
    }

    update() {
      if (this.leader !== this) return;
      if (this.dataset.libraryShowAvailability === 'false') this.availability = 'all';
      const words = this.input.value.trim().split(/\s+/).map(word => this.normalize(word)).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const inCategory = this.category === 'all' || card.dataset.libraryCategory === this.category || card.dataset.librarySecondaryCategory === this.category;
        const inAvailability = this.availability === 'all' || (card.dataset.libraryAvailability || 'current') === this.availability;
        const matches = words.every(word => this.index.get(card).includes(word));
        card.hidden = !(inCategory && inAvailability && matches);
        if (!card.hidden) count++;
      });
      this.groups.forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('[data-library-card]')).some(card => !card.hidden);
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.libraryFilter === this.category)));
      this.availabilityButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.libraryAvailability === this.availability)));
      this.members.forEach(member => {
        member.hidden = member !== this && !Array.from(member.querySelectorAll('[data-library-card]')).some(card => !card.hidden);
      });
      const visibleMembers = this.members.filter(member => !member.hidden);
      visibleMembers.forEach((member, index) => {
        member.classList.toggle('prism-fc-library--joined-next', index < visibleMembers.length - 1);
        member.classList.toggle('prism-fc-library--first-results', index === 1 && !Array.from(this.querySelectorAll('[data-library-card]')).some(card => !card.hidden));
      });
      this.querySelector('[data-library-status]').textContent = prismFcText(count === 1 ? 'manual_count_one' : 'manual_count_many', count === 1 ? '__COUNT__ manual' : '__COUNT__ manuals', { count: count });
      this.querySelector('.prism-fc-library__summary [data-library-reset]').hidden = !words.length && this.category === 'all' && this.availability === 'all';
      this.querySelector('[data-library-empty]').hidden = count !== 0;
    }

    disconnectedCallback() {
      clearTimeout(this.searchTimer);
      this.controller?.abort();
      this.controller = null;
      libraries.delete(this);
      refreshLibraries();
    }
  }

  customElements.define('prism-fc-manual-library', PrismManualLibrary);
})();

/* The gateway reads the directory; it does not maintain a second manual list. */
(function () {
  'use strict';

  if (customElements.get('prism-fc-manual-finder')) return;
  const directories = new Map();
  const normalize = prismFcNormalize;

  function safeUrl(value, base) {
    if (!value) return null;
    try {
      const url = new URL(value, base);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
    } catch (_) {
      return null;
    }
  }

  function loadDirectory(url) {
    if (directories.has(url)) return directories.get(url);
    const request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok || new URL(response.url || url).origin !== location.origin) throw new Error('Directory unavailable');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const seen = new Set();
        const entries = [];
        doc.querySelectorAll('prism-fc-manual-library [data-library-card]').forEach(card => {
          const title = card.querySelector('.prism-fc-library__card-title')?.textContent.trim();
          const href = safeUrl(prismFcLocalUrl(card.querySelector('a.prism-fc-library__card')?.getAttribute('href')), url);
          if (!title || !href) return;
          // Keep different named kites that share a manual, but avoid duplicate cards.
          const key = title + '\n' + href;
          if (seen.has(key)) return;
          seen.add(key);
          const image = card.querySelector('.prism-fc-library__image img');
          const thumbnail = image?.getAttribute('srcset')?.split(',')[0].trim().split(/\s+/)[0] || image?.getAttribute('src');
          entries.push({
            title,
            href,
            image: safeUrl(thumbnail, url),
            subtitle: card.querySelector('.prism-fc-library__subtitle')?.textContent.trim() || '',
            discontinued: card.dataset.libraryAvailability === 'discontinued',
            name: normalize(title),
            search: normalize(card.dataset.librarySearchText || title)
          });
        });
        if (!entries.length) throw new Error('No manual listings found');
        return entries;
      } finally {
        clearTimeout(timeout);
      }
    })();
    directories.set(url, request);
    request.catch(() => directories.delete(url));
    return request;
  }

  class PrismManualFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.input = this.querySelector('[data-finder-input]');
      this.form = this.querySelector('[data-finder-form]');
      this.results = this.querySelector('[data-finder-results]');
      this.status = this.querySelector('[data-finder-status]');
      this.all = this.querySelector('[data-finder-all]');
      this.retry = this.querySelector('[data-finder-retry]');
      const source = safeUrl(prismFcLocalUrl(this.dataset.directoryUrl), location.href);
      if (!source || new URL(source).origin !== location.origin) return;
      this.url = new URL(source);
      // Preserve an explicitly selected unpublished theme during owner testing.
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) this.url.searchParams.set('preview_theme_id', preview);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form.hidden = false;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.render(), 120);
      }, options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        location.assign(this.searchUrl());
      }, options);
      this.retry.addEventListener('click', () => this.load(), options);
      this.load();
    }

    searchUrl() {
      const url = new URL(this.url);
      const query = this.input.value.trim();
      if (query) url.searchParams.set('manual_search', query);
      else url.searchParams.delete('manual_search');
      return url.href;
    }

    async load() {
      if (this.loading) return;
      const connection = this.controller;
      this.loading = true;
      this.failed = false;
      this.render();
      try {
        const entries = await loadDirectory(this.url.href);
        if (connection.signal.aborted) return;
        this.entries = entries;
      } catch (_) {
        if (connection.signal.aborted) return;
        this.failed = true;
      } finally {
        if (!connection.signal.aborted) {
          this.loading = false;
          this.render();
        }
      }
    }

    render() {
      const query = this.input.value.trim();
      const words = query.split(/\s+/).map(normalize).filter(Boolean);
      this.results.replaceChildren();
      this.results.hidden = true;
      this.all.hidden = !words.length;
      this.all.href = this.searchUrl();
      this.retry.hidden = !this.failed || !words.length;
      this.results.setAttribute('aria-busy', String(this.loading));
      if (!words.length) {
        this.status.textContent = '';
        return;
      }
      if (this.loading) {
        this.status.textContent = prismFcText('manuals_loading', "Loading manuals…");
        return;
      }
      if (this.failed) {
        this.status.textContent = prismFcText('search_failed', "Search is temporarily unavailable. Try again or use the Product Manuals card below.");
        return;
      }
      const name = normalize(query);
      const score = entry => entry.name === name ? 0 : entry.name.startsWith(name) ? 1 : 2;
      const matches = (this.entries || []).filter(entry => words.every(word => entry.search.includes(word)))
        .sort((a, b) => score(a) - score(b));
      this.status.textContent = matches.length
        ? prismFcText(matches.length > 5 ? 'matches_limited' : matches.length === 1 ? 'matches_one' : 'matches_many', matches.length > 5 ? 'Showing 5 of __COUNT__ matching manuals.' : '__COUNT__ matching manuals.', { count: matches.length })
        : prismFcText('search_none', "No manuals found. Try another kite name or use the Product Manuals card below.");
      matches.slice(0, 5).forEach(entry => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = entry.href;
        link.className = 'prism-fc-hub__search-result';
        if (entry.image) {
          const image = document.createElement('img');
          image.src = entry.image;
          image.alt = '';
          image.width = 64;
          image.height = 64;
          image.loading = 'lazy';
          image.addEventListener('error', () => image.remove(), { once: true });
          link.append(image);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = entry.title;
        copy.append(title);
        [entry.subtitle, entry.discontinued ? prismFcText('discontinued', "Discontinued") : ''].filter(Boolean).forEach(text => {
          const detail = document.createElement('span');
          detail.className = 'prism-fc-hub__result-detail';
          detail.textContent = text;
          copy.append(detail);
        });
        link.append(copy);
        item.append(link);
        this.results.append(item);
      });
      this.results.hidden = !matches.length;
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.loading = false;
    }
  }

  customElements.define('prism-fc-manual-finder', PrismManualFinder);
})();
